// extracted by mini-css-extract-plugin
export default {"pageIcon":"Page_pageIcon__BGwne"};